/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Agency'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021  Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeAgency from '../../../components/agency/Home.vue'; // 'Home-Agency' ..


export const routesagency = [
    {
        path: '',
        component: HomeAgency,
    },
];
